<template>
  <div v-if="[2,3,4].includes(logged_in_user.group_id)">
    <div class="row">
      <div class="col-12">
        <h2>Administration</h2>
        <hr>
      </div>
    </div>
    <!--Small -> Medium Screen Navigation-->
    <div class="row d-lg-none">
      <div class="col-12">
        <label for="ddlNavigation">Navigation</label>
        <select class="form-control" id="ddlNavigation" v-model="selected"
                @change="routerPush">
          <option value="AdminDashboard">Dashboard</option>
          <option value="AdminSiteIndex" v-if="[3, 4].includes(logged_in_user.group_id)">Site</option>
          <optgroup label="Zone Map">
            <option value="AdminMapIndex">Map</option>
            <option value="AdminZoneExceptionIndex">Zone Exceptions</option>
          </optgroup>
          <option value="AdminUsersIndex">Users</option>
          <option value="AdminContactsIndex">Contacts</option>
          <option value="AdminIntercomCommands">Intercom</option>
          <optgroup label="Machine">
            <option value="AdminMachinePower">Power</option>
            <option value="AdminMachineStorage">Storage</option>
            <option value="AdminMachineTFTPIndex">TFTP</option>
            <option value="AdminMachineFirewall" v-if="machine_type === 'Cloud'">Firewall</option>
            <option value="AdminMachineHostName" v-if="machine_type === 'Box'">Host Name</option>
            <option value="AdminMachineNetwork" v-if="machine_type === 'Box'">Network Settings</option>
            <option value="AdminMachineDNSIndex" v-if="machine_type === 'Box'">DNS</option>
            <option value="AdminMachineTimeZone">Time Zone</option>
            <option value="AdminMachineNTPEdit">NTP Server</option>
            <option value="AdminMachineTimeServerIndex">Time Server</option>
            <option value="AdminMachineUpdateServer" v-if="machine_type === 'Box'">Update Server</option>
          </optgroup>
          <option value="AdminFileImport">File Import</option>
          <optgroup label="Backup & Restore">
            <option value="AdminBARLocationsIndex">Locations</option>
            <option value="AdminBARScheduleIndex">Backup Schedule</option>
            <option value="AdminBARManualBackup">Manual Backup</option>
            <option value="AdminBARRestore">Restore</option>
          </optgroup>
        </select>
      </div>
    </div>
    <!--Large Screen Navigation-->
    <div class="row d-none d-lg-block">
      <div class="col-12">
        <ul class="nav nav-tabs outer">
          <li class="nav-item">
            <router-link :to="{ name: 'AdminDashboard' }" class="nav-link">Dashboard</router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name: 'LogIndex' }" class="nav-link">Log</router-link>
          </li>
          <li>
            <router-link :to="{ name: 'AdminSiteIndex' }" v-if="[3, 4].includes(logged_in_user.group_id)" class="nav-link">Site</router-link>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true"
               aria-expanded="false">Zone Map</a>
            <div class="dropdown-menu">
              <router-link :to="{ name: 'AdminMapIndex' }" class="dropdown-item">Map</router-link>
              <router-link :to="{ name: 'AdminZoneExceptionIndex' }" class="dropdown-item">Zone Exception</router-link>
            </div>
          </li>
          <li class="nav-item">
            <router-link :to="{ name: 'AdminUsersIndex' }" class="nav-link">Users</router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name: 'AdminContactsIndex' }" class="nav-link">Contacts</router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name: 'AdminIntercomCommands' }" class="nav-link">Intercom</router-link>
          </li>
          <li class="nav-item dropdown" v-if="[3, 4].includes(logged_in_user.group_id)">
            <a class="nav-link dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true"
               aria-expanded="false">Machine</a>
            <div class="dropdown-menu">
              <router-link :to="{ name: 'AdminMachinePower' }" class="dropdown-item">Power</router-link>
              <router-link :to="{ name: 'AdminMachineStorage' }" class="dropdown-item">Storage</router-link>
              <router-link :to="{ name: 'AdminMachineTFTPIndex' }" class="dropdown-item">TFTP</router-link>
              <router-link :to="{ name: 'AdminMachineFirewall' }" class="dropdown-item" v-if="machine_type === 'Cloud'">Firewall</router-link>
              <router-link :to="{ name: 'AdminMachineHostName' }" class="dropdown-item" v-if="machine_type === 'Box'">Host Name</router-link>
              <router-link :to="{ name: 'AdminMachineNetwork' }" class="dropdown-item" v-if="machine_type === 'Box'">Network Settings</router-link>
              <router-link :to="{ name: 'AdminMachineDNSIndex' }" class="dropdown-item" v-if="machine_type === 'Box'">DNS</router-link>
              <router-link :to="{ name: 'AdminMachineTimeZone' }" class="dropdown-item">Time Zone</router-link>
              <router-link :to="{ name: 'AdminMachineNTPEdit' }" class="dropdown-item">NTP Server</router-link>
              <router-link :to="{ name: 'AdminMachineTimeServerIndex' }" class="dropdown-item">Time Server</router-link>
              <router-link :to="{ name: 'AdminMachineUpdateServer' }" class="dropdown-item" v-if="machine_type === 'Box'">Update Server</router-link>
            </div>
          </li>
          <li class="nav-item">
            <router-link :to="{ name: 'AdminFileImport' }" class="nav-link">File Import</router-link>
          </li>
          <li class="nav-item dropdown" v-if="[3, 4].includes(logged_in_user.group_id)">
            <a class="nav-link dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true"
               aria-expanded="false">Backup & Restore</a>
            <div class="dropdown-menu">
              <router-link :to="{ name: 'AdminBARLocationsIndex' }" class="dropdown-item">Locations</router-link>
              <router-link :to="{ name: 'AdminBARScheduleIndex' }" class="dropdown-item">Backup Schedule</router-link>
              <router-link :to="{ name: 'AdminBARManualBackup' }" class="dropdown-item">Manual Backup</router-link>
              <router-link :to="{ name: 'AdminBARRestore' }" class="dropdown-item">Restore</router-link>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-12">
          <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import router from '../../router'

export default {
  data: function () {
    return {
      selected: 'AdminDashboard'
    }
  },
  computed: {
    ...mapGetters({
      logged_in_user: 'loggedInUser',
      machine_type: 'machineType'
    })
  },
  methods: {
    routerPush () {
      router.push({ name: this.selected })
    }
  }
}
</script>
